import { DATA_NOT_AVAILABLE_VALUE } from '../../../../common/api/api-interfaces';
import {
  MetricCategoryId,
  MetricId,
} from '../../../../common/graphql/generated/graphql-sdk';
import { MetricStore } from '../../../../common/metrics/metric-store';
import { formatPercentageNumber } from '../../../../common/utilFunctions/chartConfigs';
import { enumValues } from '../../../../common/utilFunctions/pure-utils';
import { percentage } from '../../../../common/utilFunctions/utils';
import { CellValGetter } from '../BalanceSheetTable';
import {
  DELTA_PERCENTAGE,
  PbsServiceResponseData,
  TimeHeaderData,
} from '../types';

export const timeHeaderCellValGetter: CellValGetter = (
  dataToUse,
  timeHeaderVal,
  selectedMeasure
) => {
  // Very weird code here, ideally should have stored as
  // object so I don't have to do this find thing
  const cellData = dataToUse.timeHeadersData.find(
    (d: TimeHeaderData) => d.label === timeHeaderVal
  )!.data;
  const cellVal = cellData?.[selectedMeasure];
  return cellVal ?? null;
};

export const fixedHeaderCellValGetter: CellValGetter = (
  dataToUse,
  fixedHeaderVal,
  selectedMeasure
) => {
  const cellData = dataToUse.fixedHeadersData[fixedHeaderVal];
  const cellVal = cellData?.[selectedMeasure];
  return cellVal ?? null;
};

export const benchmarkHeaderCellValGetter: CellValGetter = (
  dataToUse,
  benchmarkHeaderVal,
  selectedMeasure
) => {
  const cellData = dataToUse.benchmarkHeadersData![benchmarkHeaderVal];
  const cellVal = cellData?.[selectedMeasure];
  return cellVal ?? null;
};

export const getCellValForSegmentMeasure = (
  cellValGetter: (dataToUse: PbsServiceResponseData) => number | null,
  data: PbsServiceResponseData,
  totalData: PbsServiceResponseData,
  isPercentage: boolean
) => {
  const segmentCellVal = cellValGetter(data);
  const totalCellVal = cellValGetter(totalData);
  if (segmentCellVal === null || totalCellVal === null) {
    return null;
  }
  const cellVal = isPercentage
    ? percentage(segmentCellVal, totalCellVal)
    : segmentCellVal;
  return cellVal;
};

export const getFormattedValForHeaderGetter =
  (cellValGetter: CellValGetter) =>
  (
    headerVal: string,
    selectedMeasure: MetricId,
    data: PbsServiceResponseData,
    totalData: PbsServiceResponseData,
    isPercentage: boolean,
    metricStore: MetricStore
  ) => {
    const cellVal = getCellValForSegmentMeasure(
      (dataToUse) => cellValGetter(dataToUse, headerVal, selectedMeasure),
      data,
      totalData,
      isPercentage
    );
    if (cellVal === null) {
      return DATA_NOT_AVAILABLE_VALUE;
    }
    const formattedVal =
      isPercentage || headerVal === DELTA_PERCENTAGE
        ? formatPercentageNumber(cellVal)
        : metricStore.formatMetricValue(cellVal, selectedMeasure);
    return formattedVal;
  };

export const getFormattedValForTimeHeader = getFormattedValForHeaderGetter(
  timeHeaderCellValGetter
);
export const getFormattedValForFixedHeader = getFormattedValForHeaderGetter(
  fixedHeaderCellValGetter
);
export const getFormattedValForBenchmarkHeader = getFormattedValForHeaderGetter(
  benchmarkHeaderCellValGetter
);

export const pbsCategorySortOrder: MetricCategoryId[] =
  enumValues(MetricCategoryId);
